// extracted by mini-css-extract-plugin
export default {"container":"b_G0hH","active":"wuXEGo","placeholder-shimmer":"E48klc","placeholderShimmer":"E48klc","universal":"Ngae04","dark":"R6t3cB","light":"vWigZM"};